export * from './faq.page'
